import { Icon } from '@iconify/react';
import React from 'react';

export default function ContactInfoWidget() {
  return (
    <ul className="cs_contact_widget">
      <li>
        <i className="cs_accent_bg">
          <Icon icon="ep:location" />
        </i>
        20 Rue de Longchamp, 75116 Paris
      </li>
      <li>
        <i className="cs_accent_bg">
          <Icon icon="fluent:call-24-regular" />
        </i>
        +33 01 56 91 08 46
      </li>
      <li>
        <i className="cs_accent_bg">
          <Icon icon="bi:clock" />
        </i>
        Lun–Ven 09:00–20:00 · Sam 09:00–18:00
      </li>
    </ul>
  );
}
